import type { Language } from "@/data/model/Enums";

export interface ICurrentIdentityService {
    getIdentityId(): string | undefined;
    getLanguage(): Language;
}

export class CurrentIdentityService {
    private static instance: ICurrentIdentityService;

    public static init(currentIdentityService: ICurrentIdentityService) {
        CurrentIdentityService.instance = currentIdentityService;
    }

    public static getIdentityId(): string | undefined {
        const identityId = CurrentIdentityService.instance?.getIdentityId();
        return identityId;
    }

    public static getLanguage(): Language {
        const language = CurrentIdentityService.instance?.getLanguage();
        return language;
    }
}
